import { useSyncExternalStore } from 'react';
import { getImpersonatorFromToken, subscribeToToken } from '../utils/TokenUtils';

/**
 * Whether this is a manager's read-only view of a homeowner's portal.
 *
 * Screens with a write — booking, cancelling — disable it and say why.
 * The server refuses every write on such a session with a 403 anyway;
 * this is so nobody fills in a form the server will throw away.
 * Subscribed rather than read once, for the reason `ImpersonationBanner`
 * gives.
 */
export const useImpersonating = (): boolean =>
  !!useSyncExternalStore(subscribeToToken, getImpersonatorFromToken);
